/**
 * SalesDashboard - Рабочий стол сейла
 *
 * Главная страница дашборда для роли SALES.
 * Содержит виджеты: Мой день, Статистика, Требуют внимания, Пул организаций, Воронка.
 */
import React from 'react';
import {
  Box,
  Stack,
  Grid,
  Title,
  Text,
  Group,
} from '@mantine/core';
import { IconLayoutDashboard } from '@tabler/icons-react';
import { useSession } from '../../context/SessionContext';
import tokens from '../../theme/designTokens';
import MyDayCalendarWidget from './MyDayCalendarWidget';
import MyStatsWidget from './MyStatsWidget';
import NeedsAttentionWidget from './NeedsAttentionWidget';
import OrganizationPoolWidget from './OrganizationPoolWidget';
import MyFunnelWidget from './MyFunnelWidget';

const SalesDashboard = () => {
  const { user } = useSession();

  const userName = user?.full_name || user?.first_name || user?.email || 'Сотрудник';

  return (
    <Box px="md" py="md">
      <Stack gap="lg">
        {/* Заголовок */}
        <Group justify="space-between" align="flex-end">
          <Box>
            <Group gap="xs">
              <IconLayoutDashboard
                size={28}
                style={{ color: tokens.colors.brand.primary }}
              />
              <Title order={2} style={{ color: tokens.colors.brand.primary }}>
                Моё рабочее место
              </Title>
            </Group>
            <Text c="dimmed" size="sm" mt={4}>
              Добро пожаловать, {userName}
            </Text>
          </Box>
        </Group>

        {/* Основная сетка виджетов */}
        <Grid gutter="md">
          {/* Мой день (календарь) - на всю ширину на мобильных, 8 колонок на десктопе */}
          <Grid.Col span={{ base: 12, md: 8 }}>
            <MyDayCalendarWidget />
          </Grid.Col>

          {/* Статистика - справа */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <MyStatsWidget />
          </Grid.Col>
        </Grid>

        {/* Второй ряд виджетов */}
        <Grid gutter="md">
          {/* Требуют внимания */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <NeedsAttentionWidget />
          </Grid.Col>

          {/* Пул организаций */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <OrganizationPoolWidget />
          </Grid.Col>

          {/* Воронка */}
          <Grid.Col span={{ base: 12, md: 4 }}>
            <MyFunnelWidget />
          </Grid.Col>
        </Grid>
      </Stack>
    </Box>
  );
};

export default SalesDashboard;
